import React from 'react';
import SkeletonBlock from './SkeletonBlock';

export default function CardGridSkeleton({
  count = 12,
  itemSize = 72,
  label = 'Loading',
  className = '',
}) {
  return (
    <div
      className={`sk-host sk-card-grid ${className}`.trim()}
      role="status"
      aria-busy="true"
      aria-label={label}
    >
      {Array.from({ length: count }, (_, index) => (
        <div className="sk-card-grid__item" key={index}>
          <SkeletonBlock variant="circle" width={itemSize} height={itemSize} />
          <SkeletonBlock width="70%" height={10} />
        </div>
      ))}
    </div>
  );
}
